var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletepost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 189,
    viewBox: "0 0 150 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.7554 17.9841L55.0154 18.126L55.3022 18.052L69.2111 14.463L113.874 38.921L117.65 52.1829L117.736 52.4846L118.011 52.6353L148.951 69.5837L139.294 85.4295L13.993 16.8472L23.6503 1.00098L54.7554 17.9841ZM20.1268 169.199V169.949H20.8768H104.384H105.134V169.199V101.876V101.432L104.744 101.218L46.9157 69.5366L46.7473 69.4443H46.5553H20.8768H20.1268V70.1943V169.199ZM0.75 169.199V51.1434H52.7309L124.511 90.4397V169.199C124.511 174.238 122.401 179.08 118.63 182.656C114.858 186.234 109.735 188.25 104.384 188.25H20.8768C15.5264 188.25 10.4026 186.234 6.6308 182.656C2.86031 179.08 0.75 174.238 0.75 169.199Z",
    fill: "#FF0000",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletepost);
export default __webpack_public_path__ + "static/media/Delete post.ecdbfc1a11e688e4355e380c85dcc0fe.svg";
export { ForwardRef as ReactComponent };